export default "__VITE_ASSET__WHCwxo3D__"